// As of writing, Firefox 81 stable (and some beta versions of Firefox 80) is the latest version and introduces severe bugs into IntersectionObserver.
// Until these bugs are resolved, delete the native IntersectionObserver objects to force the polyfill installation.
if (navigator.userAgent.toLowerCase().indexOf(`firefox`) > -1) {
  delete window.IntersectionObserver;
  delete window.IntersectionObserverEntry;
}
